<template>
  <div
    class="d-flex justify-content-between align-items-start flex-wrap gap-3 mb-3"
  >
    <div>
      <RouterLink
        :to="{ name: 'ForwardsOverview' }"
        class="eyebrow-label text-decoration-none"
      >
        {{ $t("forwards.deals.header.back") }}
      </RouterLink>
      <h2 class="mb-1">{{ deal.name }}</h2>
      <p class="text-body-tertiary mb-2">
        <span v-if="deal.counterparty_name">{{
          $t("forwards.deals.header.buyer", { buyer: deal.counterparty_name })
        }}</span>
        <span v-else>{{ $t("forwards.deals.header.buyer_missing") }}</span>
        <span v-if="deal.signed_at">
          · {{ $t("forwards.deals.header.signed_at", { date: signedAt }) }}
        </span>
      </p>
      <DealBadgesComponent
        :status="deal.status"
        :flags="deal.flags"
        :isPayAsProduced="deal.type === 'pay_as_produced'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatDate } from "@/composables/formatUtils";
import DealBadgesComponent from "@/forwards2/deals/DealBadgesComponent.vue";
import type { DealResponse } from "@/forwards2/forwardsTypes";
import { computed } from "vue";
import { RouterLink } from "vue-router";

/** The deal's identity line: who bought what, in which state, with room for the page's actions. */
const props = defineProps<{
  deal: DealResponse;
}>();

const signedAt = computed(() =>
  props.deal.signed_at ? formatDate(props.deal.signed_at) : ""
);
</script>
